export default __webpack_public_path__ + "static/media/5.9d16b8d8.jpg";